import { Stack, Text } from "@chakra-ui/react";

export default function Privacy() {
	return (
		<Stack flex={1} align="center" p={8} borderRadius="4xl">
			<Stack className="center" maxW="2xl">
				<Stack gap={8}>
					<Text fontSize="2xl" fontWeight="bold">
						Privacy Policy
					</Text>
					<Text color="fg.muted">
						We do not collect, store, or transmit any personal information, contact details, or identifying
						data.
					</Text>
				</Stack>
			</Stack>
		</Stack>
	);
}
